import React,{useState,useEffect} from 'react';
import logo from '../../../img/qbs_learning.png';
import { getSingleCondidate } from '../../../Redux/Actions/newJoinerAction';
import { useDispatch,useSelector } from 'react-redux';

import {sendFormAuthCode} from '../../HR/onboarding/api/Calls';

const EmailVerification = ({emailCheck,setIsCheckTwoFectorAuthtication}) =>{

    const dispatch = useDispatch();
    const { onecondidate } = useSelector( (state) => state.NewJoinerReducer );
    const [verification,setVerification] = useState('');
    const [Error,setError] = useState('');
    const [minutes, setMinutes] = useState(1);
    const [seconds, setSeconds] = useState(30);
    const [otpsms,setOtpsms] =useState('');

    const resendOTP = () => {
      sendFormAuthCode(emailCheck).then((data) =>{
        setMinutes(1);
          setSeconds(30);
        
     })
      
    };

    useEffect(() => {
      const interval = setInterval(() => {
        if (seconds > 0) {
          setSeconds(seconds - 1);
        }
    
        if (seconds === 0) {
          if (minutes === 0) {
            clearInterval(interval);
          } else {
            setSeconds(59);
            setMinutes(minutes - 1);
          }
        }
      }, 1000);
    
      return () => {
        clearInterval(interval);
      };
    }, [seconds]);

    useEffect(()=>{
      dispatch(getSingleCondidate(emailCheck))
    },[emailCheck,verification])

    const handleVerificationCode = (e) =>{
       const VerificationCode = e.target.value;
       setVerification(VerificationCode);

    }
    const validateVericationCode = (e) =>{
      e.preventDefault();
        const code = onecondidate?.verification_code
        if(verification == code && seconds > 0){
            setError('green');
            setIsCheckTwoFectorAuthtication(1)
        }else{
            setError('red');
            setIsCheckTwoFectorAuthtication(0)
        }
        
    }
  
    return(
        <>
            <main className="user_maincontainer">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-4" />
            <div className="col-md-4">
              <div className="verify_box mb20 mt30">
                <div className="company_logo">
                  <img src={logo} alt="logo" className="company_logo" />
                </div>
                <div className="verify_ttl text-center">
                  <h4>Email Verification Code</h4>
                  <p>Please enter the 4-digit verification code that was sent to your Email Id. The code is valid for 5 minutes only.</p>
                </div>
                <form onSubmit={validateVericationCode}>
                    <div className="formblk mb15">
                    <label className="form-label">Verification Code {otpsms}</label>
                    <div className={`form-input ${ Error ==='red' ? 'redvalidation_input':'greenvalidation_input'}`}>
                        <input type="text" onChange={handleVerificationCode} className="form-control" />
                    </div>
                    </div>
                    <div className="countdown-text">
                      {seconds > 0 || minutes > 0 ? (
                        <p>
                          Time Remaining: {minutes < 10 ? `0${minutes}` : minutes}:
                          <span>{seconds < 10 ? `0${seconds}` : seconds}</span>
                        </p>
                      ) : (
                        <>
                         <p>Didn't recieve code?
                          <span className="float-end hand"
                          disabled={seconds > 0 || minutes > 0}
                          style={{
                            color: seconds > 0 || minutes > 0 ? "#DFE3E8" : "#FF5630",
                          }}
                          onClick={resendOTP}
                        >
                          Resend OTP
                        </span></p>
                        </>
                       
                      )}
                       
                        
                      </div>
                    <button type="submit" className="button_login" >Submit</button>
                </form>
                
              </div>
              <div className="dashfooter text-center">
                @2023 QBS Learning. All rights reserved.
              </div>
            </div>
            <div className="col-md-4" />
          </div>
        </div>
      </main>
        </>
    )
}
export default EmailVerification